import { defineChain } from "viem";
import { getDefaultConfig } from "@rainbow-me/rainbowkit";

// Get project ID from WalletConnect (you can get this from https://cloud.walletconnect.com)
const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || 'YOUR_PROJECT_ID';

const humanityTestnet = defineChain({
  id: 7080969,
  name: "Humanity Chain Testnet",
  nativeCurrency: {
    decimals: 18,
    name: "Humanity",
    symbol: "H",
  },
  rpcUrls: {
    default: {
      http: [
        "https://humanity-testnet.g.alchemy.com/v2/gXL5sCsyDE0U_0Ej4nOAqf5iE7NtCCKC",
      ],
    },
  },
  blockExplorers: {
    default: {
      name: "Humanity Testnet",
      url: "https://humanity-testnet.explorer.alchemy.com/",
    },
  },
});

export const config = getDefaultConfig({
  appName: "DeFi Lending Protocol",
  projectId: projectId,
  chains: [humanityTestnet],
  ssr: false,
});
